module.exports = __webpack_public_path__ + "static/media/logos_squares_Sup_HKIE_YMC.df9ce84b.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/logos_squares_Sup_HKIE_YMC.png
// module id = 68
// module chunks = 0